import React from 'react';
import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { CartDrawer } from '../cart/CartDrawer';
import { FloatingCart } from '../cart/FloatingCart';
export function SiteLayout() {
  return <div className="min-h-screen w-full bg-white" data-id="element-276" data-mp="egifqutjg2s3">
      <ScrollToTop data-id="element-277" data-mp="3mzgakzv1tqdj" />
      <AnnouncementBar data-id="element-278" data-mp="3myy4lbil3xsf" />
      <Header data-id="element-279" data-mp="3mwbvh7g1pa83" />
      <main data-id="element-280" data-mp="3hzbu39u54vnb">
        <Outlet data-id="element-281" data-mp="3hztxcqf80a4q" />
      </main>
      <Footer data-id="element-282" data-mp="3i0mv51w7bpaq" />
      <FloatingCart data-id="element-283" data-mp="3i0wjym5ifqeu" />
      <CartDrawer data-id="element-284" data-mp="3hxh59kfr0jdy" />
    </div>;
}